<template>
  <div class="container">
    <h2 class="h2 text-left col-12 mb-5 mt-3" style="color: #010D4A;">
      Data Surveyor
    </h2>
    <div v-show="loading">
      <Loading />
    </div>
    <v-client-table :data="tableData" :columns="columns" :options="options">
    </v-client-table>
  </div>
</template>

<script>
import DataService from "@/services/data.service";
import Loading from "@/components/Loading.vue";

export default {
  name: "Surveyor",
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      columns: ["nama_lengkap", "nm_fakultas", "nm_program_studi", "tlpn_hp"],
      tableData: [],
      options: {
        headings: {
          nama_lengkap: "Nama Lengkap  ",
          nm_fakultas: "fakultas  ",
          nm_program_studi: "Program Studi  ",
          tlpn_hp: "Telepon "
        },
        sortable: true,
        filterable: true,
        hiddenColumns: ["id"],
        texts: {
          count:
            "Menampilkan {from} sampai {to} dari {count} data|{count} data|Satu data",
          first: "Pertama",
          last: "Terahkir",
          filter: false,
          filterPlaceholder: "Pencarian",
          limit: false,
          page: "Page:",
          noResults: "Data tidak ada",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns"
        },
        sortIcon: {
          is: "fa fa-sort",
          base: "font-awesome",
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          align: "center"
        },
        pagination: {
          show: true,
          dropdown: false,
          chunk: 5,
          edge: false,
          align: "center",
          nav: "fixed"
        }
      }
    };
  },
  mounted() {
    this.loading = true;
    DataService.getSurveyors().then(res => {
      this.tableData = res.data.surveyors;
      if (this.tableData) {
        this.loading = false;
        return;
      }
    });
  }
};
</script>

<style scoped>
.container {
  padding: 20px !important;
}
</style>
